var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "overlay",
      staticClass: "layout-overlay",
      class: { "is-visible": _vm.isVisible },
      attrs: {
        tabindex: "-1",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": _vm.title
      }
    },
    [
      _c("div", { staticClass: "layout-overlay__title" }, [
        _vm.returnButtonVisible
          ? _c(
              "button",
              {
                staticClass: "btn--clear",
                attrs: { "aria-label": "zamknij filtry " },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [
                _c("ArrowRightIcon", {
                  staticClass: "layout-overlay__icon",
                  attrs: { height: "22" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "h1" }, [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout-overlay__btn" }, [_vm._t("button")], 2)
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }